// components/RestaurantReviews.jsx
import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getRestaurantReviews } from "../../../../../api/user/restaurants";
import { AiFillStar } from "react-icons/ai";
import Pagination from "../../../../../components/common/Pagination";
import { useTranslation } from "../../../../../hooks/useTranslation";

const RestaurantReviews = ({ restaurantId }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["restaurant-reviews", restaurantId, page],
    queryFn: () => getRestaurantReviews({ page, restaurantId }),
    keepPreviousData: true,
  });

  if (isLoading)
    return (
      <div className="text-center">{t("restaurantDetail").loadingreviews}</div>
    );
  if (isError)
    return (
      <div className="text-center">
        {" "}
        {t("restaurantDetail").failedtoretrievereviews}
      </div>
    );

  return (
    <div className="">
      {data?.data?.reviews?.length === 0 && (
        <div className="text-center">{t("restaurantDetail").noreviews}</div>
      )}
      {data?.data?.reviews?.map((review) => (
        <div key={review._id} className="flex space-x-4 border-b pb-4">
          <img
            src={review.userId?.profilePicture}
            alt="User profile"
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <div className="font-semibold text-gray-800">
              {review.userId?.name}
            </div>
            <div className="flex text-yellow-500 text-sm">
              {[...Array(review.rating)].map((_, i) => (
                <AiFillStar key={i} />
              ))}
            </div>
            <p className="text-gray-600 mt-1">{review.comment}</p>
          </div>
        </div>
      ))}

      {data?.data?.pagination?.pages > 1 && (
        <Pagination
          page={data?.data?.pagination?.page}
          totalPages={data?.data?.pagination?.pages}
          setPage={setPage}
        />
      )}
    </div>
  );
};

export default RestaurantReviews;
